import { BeneficialOwnerControlType } from '@commenda/api';
import { FieldWrapper, InputErrorMessage, Label } from '@commenda/kakashi';
import { ControlTypePicker } from './ControlTypePicker';

interface UboControlTypeSectionProps {
  value: BeneficialOwnerControlType | undefined;
  onChange: (value: BeneficialOwnerControlType) => void;
  error?: string;
}

export const UltimateBeneficialOwnerControlTypeSection = ({
  value,
  onChange,
  error,
}: UboControlTypeSectionProps) => (
  <div className="flex flex-col gap-xs rounded-md border-[0.5px] border-border-primary p-xl">
    <FieldWrapper>
      <Label required>UBO control type</Label>
      <ControlTypePicker value={value} onChange={onChange} />
      {error && <InputErrorMessage message={error} />}
    </FieldWrapper>
  </div>
);
